import { Typography } from '@mui/material';
import type { StyleRules, WithStyles } from '@mui/styles';
import withStyles from '@mui/styles/withStyles';

const styles = (): StyleRules => ({
  billingMonth: {
    borderBottom: '1px solid',
    padding: 1
  }
});

type BillingLabelOwnProps = { billingMonth: string };
type BillingLabelProps = BillingLabelOwnProps & WithStyles<typeof styles>;

const BillingLabel: React.FC<BillingLabelProps> = ({
  classes,
  billingMonth
}) => (
  <Typography variant="h6">
    <span className={classes.billingMonth} data-cy="claimbillingMonth">
      請求月：{billingMonth}
    </span>
  </Typography>
);

export default withStyles(styles)(BillingLabel);
